import React from 'react';

type ClearCartConfirmModalProps = {
  onCancel: () => void;
  onConfirm: () => void;
  overlayClassName?: string;
};

export function ClearCartConfirmModal({ onCancel, onConfirm, overlayClassName = '' }: ClearCartConfirmModalProps) {
  return (
    <>
      <div
        className={`chunkzters-drawerOverlay chunkzters-drawerOverlay--confirm ${overlayClassName}`.trim()}
        onClick={onCancel}
      />
      <div
        className="position-fixed top-50 start-50 translate-middle bg-white rounded-4 p-4 chunkzters-drawerConfirmModal chunkzters-clearCartModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="clear-cart-title"
        aria-describedby="clear-cart-desc"
      >
        <div className="d-flex align-items-start gap-3 mb-4">
          <div className="chunkzters-clearCartModal-icon" aria-hidden="true">
            <i className="bi bi-trash3" />
          </div>
          <div>
            <div id="clear-cart-title" className="fw-bold mb-2 d-flex align-items-center gap-2">
              <i className="bi bi-exclamation-circle" aria-hidden />
              Clear cart?
            </div>
            <p id="clear-cart-desc" className="mb-0 chunkzters-clearCartModal-message">
              <i className="bi bi-cart-x me-1" aria-hidden />
              This will remove all items from your cart.
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-end gap-2">
          <button
            type="button"
            className="btn btn-outline-dark d-inline-flex align-items-center gap-2"
            onClick={onCancel}
          >
            <i className="bi bi-x-lg" aria-hidden />
            Cancel
          </button>
          <button
            type="button"
            className="btn chunkzters-btn-primary d-inline-flex align-items-center gap-2"
            onClick={onConfirm}
          >
            <i className="bi bi-trash" aria-hidden />
            Clear cart
          </button>
        </div>
      </div>
    </>
  );
}
